import { combineReducers } from '@ngrx/store';

import { activateAlertsReducer as activateAlerts } from '@shared/widgets/store/reducers/ui/activate-alerts.reducer';
import { showAlertToastReducer as showAlertToast } from '@shared/widgets/store/reducers/ui/show-alert-toast.reducer';
import { saveThisSearchReducer as saveThisSearch } from '@shared/widgets/store/reducers/ui/save-this-search.reducer';
import { createAlertReducer as createAlert } from '@shared/widgets/store/reducers/ui/create-alert.reducer';

export const UiWidgetsRootReducer = combineReducers({
  activateAlerts,
  showAlertToast,
  saveThisSearch,
  createAlert
});

